<template>
<el-popover
    style="text-align: right"
    placement="bottom"
    width="600"
    trigger="click">
    <el-table :data="statTable" 
        :row-class-name="tableRowClassName" @cell-dblclick="handleTableDblclick">
        <el-table-column v-for="col of columns" :key="col" :property="col" :label="col"
            :width="col===columns[0]?200:50">
        </el-table-column>
    </el-table>
    <el-button slot="reference" @click="getStat">Statistics</el-button>
</el-popover>
</template>

<style>
  .el-header {
    background-color: #d7dee7;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }

  .flagged {
    /* background-color: rgb(234, 231, 169); */
    border-color: rgb(234, 231, 169);
    /* border-width: 5px; */
  }

  .diff {
    background-color: rgb(248, 146, 146);
    /* border-color: rgb(248, 146, 146);
    border-width: 5px; */
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>

<script>
import axios from 'axios';
  export default {
    name: 'StatTable',
    data() {
      return {
        statTable: [],
        columns: [],
      }
    },
    computed: {
        
    },
    methods: {
      getStat() {
        const that = this;
        axios.post('/api/table', {}).then(function(response) {
          // console.log(response.data);
          that.statTable = response.data.table;
          that.columns = response.data.columns;
        });
      },
      tableRowClassName({row, rowIndex}) {
        row.index = rowIndex;
        if (row[this.columns[0]].startsWith('Why')) {
          return 'success-row';
        }
        return '';
      },
      handleTableDblclick(row, column) {
        if (row[this.columns[0]].startsWith('Why')) return;
        // TODO: hard code here...
        let why_name = '';
        for (const rr in this.statTable) {
          if (rr == row.index) break;
          if (this.statTable[rr][this.columns[0]].startsWith('Why')) {
            let i1 = this.statTable[rr][this.columns[0]].indexOf(' ')+1;
            let i2 = this.statTable[rr][this.columns[0]].indexOf(' ', i1);
            why_name = this.statTable[rr][this.columns[0]].substring(i1, i2);
          }
        }
        let i1 = row[this.columns[0]].indexOf(' ')+1;
        let i2 = row[this.columns[0]].indexOf(' ', i1);
        let what_name = row[this.columns[0]].substring(i1, i2);
        let how_name = column.label;
        if (how_name.startsWith('total')) how_name = '';
        this.$message({
          message: `double click ${why_name} ${what_name} ${how_name}`,
          type: 'info',
          duration: 3000,
        });
        // BUG: exist mismatches when multiple codings cooccur
        // this.select = {
        //   'Why': [this.catNames.indexOf(why_name)],
        //   'What': [this.catNames.indexOf(what_name)],
        //   'How': [this.catNames.indexOf(how_name)],
        // };
        // this.updateCards();
        this.$emit('dbclick', why_name, what_name, how_name);
      },
    },
    mounted() {
    }
  };
</script>